export const QTY_MAX_ERROR_MSG = 'Quantity exceeding maximum limit';
